/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_OriginalityInputs */

const en_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originality`)
};

const es_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalidad`)
};

const fr_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalité`)
};

const de_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalität`)
};

const ja_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナリティ`)
};

const zh_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独创性`)
};

const ar_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصالة`)
};

const id_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keaslian`)
};

const it_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalità`)
};

const ru_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинальность`)
};

const pt_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalidade`)
};

const ko_field_originality = /** @type {(inputs: Field_OriginalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오리지널 여부`)
};

/**
* | output |
* | --- |
* | "Originality" |
*
* @param {Field_OriginalityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_originality = /** @type {((inputs?: Field_OriginalityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_OriginalityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_originality(inputs)
	if (locale === "es") return es_field_originality(inputs)
	if (locale === "fr") return fr_field_originality(inputs)
	if (locale === "de") return de_field_originality(inputs)
	if (locale === "ja") return ja_field_originality(inputs)
	if (locale === "zh") return zh_field_originality(inputs)
	if (locale === "ar") return ar_field_originality(inputs)
	if (locale === "id") return id_field_originality(inputs)
	if (locale === "it") return it_field_originality(inputs)
	if (locale === "ru") return ru_field_originality(inputs)
	if (locale === "pt") return pt_field_originality(inputs)
	return ko_field_originality(inputs)
});